import React, { useState } from "react";
import "../../Styles/styles.css";
import "react-dropzone-uploader/dist/styles.css";
import States from "../../Pages/States";

const Form = ({ formik }) => {
  const [yesAbuja, setYesAbuja] = useState(false);
  const [yesKaduna, setYesKaduna] = useState(false);
  const [yesOnsite, setYesOnsite] = useState(true);
  const [noOnsite, setNoOnsite] = useState(false);

  const checkedSelected = (e) => {
    let currentState = e.target.value;
    if (currentState === "onsite") {
      console.log("onsite");
      setNoOnsite(false);
      setYesOnsite(true);
    } else {
      setNoOnsite(true);
      setYesOnsite(false);
    }
  };

  const handlePickup = (e) => {
    let currentState = e.target.value;
    if (currentState === "abuja") {
      setYesAbuja(true);
      setYesKaduna(false);
    } else {
      setYesAbuja(false);
      setYesKaduna(true);
    }
  };

  return (
    <div className="fabric_pickup">
      <p>Delivery</p>
      <select
        className="form-select style_form form-select-lg mb-3 shadow-none"
        aria-label=".form-select-lg example"
        name="delivery"
        onChange={(e) => {
          checkedSelected(e);
          formik.handleChange(e);
        }}
      >
        <option >Select delvery Option</option>
        <option value="onsite">On Site</option>
        <option value="home">Home Delivery</option>
      </select>
      <div className="home_delivery">
        <p className="p_add">Whatsapp Number</p>
        <input
          style={{
            width: "100%",
            border: "1px solid #bc9a43",
            outline: "none",
          }}
          // type="number"
          placeholder="Enter Whatsapp Number"
          className="style_textarea"
          name="whatsapp_number"
          onChange={formik.handleChange}
        />
      </div>
      <div className="delivery_address">
        {noOnsite && (
          <div className="home_delivery">
            <p className="p_add">Delivery Address</p>
            <textarea
              placeholder="Enter Delivery Address"
              className="style_textarea"
              name="delivery_address"
              onChange={formik.handleChange}
            ></textarea>

            <States {...{ formik }} />
          </div>
        )}
      </div>
      <div className="delivery_address">
        {yesOnsite && (
          <div>
            <p className="p_add">State in Nigeria</p>
            <select
              className="form-select style_form form-select-lg mb-3 shadow-none"
              aria-label=".form-select-lg example"
              name="from_state"
              onChange={(e) => {
                handlePickup(e);
                formik.handleChange(e);
              }}
            >
              <option hidden value="">
                Select Abuja/Kaduna
              </option>
              <option value="abuja">Abuja</option>
              <option value="kaduna">Kaduna</option>
            </select>
            <div className="delivery_address">
              {yesAbuja && (
                <div className="pickup_location">
                  <p className="p_add ">PickUp Location</p>
                  <div>
                    No. 28 Tennesse Crescent, Ministers hill Maitama, Abuja
                  </div>
                </div>
              )}
            </div>
            <div className="delivery_address">
              {yesKaduna && (
                <div className="k_location">
                  <p className="p_add ">PickUp Location</p>
                  <div>
                    Suite 4 Ground Floor, Hamza Zayad House, NO 10 Muhammadu
                    Buhari Way, City Centre 800283, Kaduna
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Form;
